module.exports = __webpack_public_path__ + "images/icons/lightning-gold-ec8d8affc60cda1c9db555e70df689fd.svg";